export const B2B_DROPDOWN = "B2B_DROPDOWN";
export const ADD_B2BALLIANCE = "ADD_B2BALLIANCE";
